<template>
  <span :id="id">
    <slot />
  </span>
</template>

<script>
export default {
  computed: {
    id() {
      return this.$attrs.type === "subtitle" ? "app-subtitle" : "app-title";
    }
  }
};

</script>

<style lang="sass" scoped>
#app-title
  color: #000
  font-family: Poppins
  font-size: 18px
  font-style: normal
  font-weight: 700

#app-subtitle
  // color: #907FF5
  color: #000
  font-family: Poppins
  font-size: 16px
  font-style: normal
  font-weight: 500
</style>